// extracted by mini-css-extract-plugin
export default {"muteButton":"MuteButton_muteButton__uojZX","muteImg":"MuteButton_muteImg__uCrS1"};